export const openExternalUrlViaBridge = (url: string): boolean => {
    if (window?.kmpJsBridge) {
        window.kmpJsBridge.callNative(
            "OpenExternal",
            JSON.stringify({
                url,
                timestamp: new Date().toISOString(),
            }),
        );
        return true;
    }

    return false;
};
